<template>
  <div class="common-main">
    <div v-if="pageLevel > 0">
      <CommonBreadcrumb />
    </div>
    <CommonLoading />
    <CommonMessages />
    <CommonConfirm />
  </div>
</template>

<script>
import CommonBreadcrumb from './CommonBreadcrumb';
import CommonLoading from './CommonLoading';
import CommonMessages from './CommonMessages';
import CommonConfirm from './CommonConfirm';

export default {
  name: 'Common',
  components: { CommonBreadcrumb, CommonLoading, CommonMessages, CommonConfirm },
  computed: {
    pageLevel() {
      return this.$route.matched.reduce((acc, cur) => {
        if (cur.meta.level === undefined || cur.meta.level === null) {
          return acc;
        }
        return cur.meta.level;
      }, 1);
    },
  },
};
</script>

<style scoped>
</style>
